module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-autocomplete', {
    staticClass: "inline-input",
    style: (_vm.sstyle),
    attrs: {
      "clearable": "",
      "filterable": "",
      "fetch-suggestions": _vm.SearchId,
      "placeholder": _vm.ptext,
      "suffix-icon": _vm.inputKW != '' ? '' : 'el-icon-search'
    },
    on: {
      "select": _vm.SelectApp,
      "clear": _vm.clear
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "name"
        }, [_vm._v(_vm._s(item['name']))])]
      }
    }]),
    model: {
      value: (_vm.inputKW),
      callback: function($$v) {
        _vm.inputKW = $$v
      },
      expression: "inputKW"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c817a04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/searchApp.vue
// module id = 1141
// module chunks = 2